import { render, staticRenderFns } from "./MenuOptionExtensionAssignModal.vue?vue&type=template&id=dda61a8c&"
import script from "./MenuOptionExtensionAssignModal.vue?vue&type=script&lang=js&"
export * from "./MenuOptionExtensionAssignModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports